const awsconfig = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://ldo26obvm5gpngpsf7dnsxqq4u.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AWS_IAM',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:072f9942-8e5f-4c82-bdf2-7b3513635423',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_88ZzP2EHj',
  'aws_user_pools_web_client_id': '16taoskimav33urb5gi9ii58mr',
  'aws_content_delivery_bucket': 'backends-imagebucket6194e37c-1l8uy7z99s98k',
  'aws_content_delivery_bucket_region': 'ap-northeast-1',
  'aws_content_delivery_url': 'http://backends-imagebucket6194e37c-1l8uy7z99s98k.s3-website-ap-northeast-1.amazonaws.com',
  'oauth': {}
}
export default awsconfig
